import { Box, Typography, Link, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import WarningIcon from "@mui/icons-material/Warning";
import { ScreenSizeEnum, useScreenSize } from "shared/use-screen-size";

export const InformationPage = () => {
  const { t } = useTranslation();
  const { screenSize } = useScreenSize();
  const contactEvu = "evu@evu.dk";
  const contactSupportMail = "akkord@evu.dk";
  const criticalSupportPhone = "+45 2261 6737";

  return (
    <Box sx={{ p: screenSize === ScreenSizeEnum.Mobile ? 1 : 3, color: "primary.main", height: screenSize === ScreenSizeEnum.Mobile ? "100vh" : "auto", overflowY: screenSize === ScreenSizeEnum.Mobile ? "auto" : "visible", boxSizing: "border-box" }}>
      <Box>
        <Typography variant="h3" gutterBottom sx={{ color: "primary.main" }}>
          {t("account.information.title")}
        </Typography>

        <Typography variant="body1" sx={{ marginTop: 3, color: "primary.main" }}>
          {t("account.information.helpTitle")}
        </Typography>
        <Typography variant="body1" component="a" href="https://evu.dk/akkordplus/" target="_blank" rel="noopener noreferrer" sx={{ display: "block", marginBottom: 2 }}>
          {t("account.information.helpText")}
        </Typography>

        <Typography variant="body1" sx={{ marginTop: 3, color: "primary.main" }}>
          {t("account.information.newsTitle")}
        </Typography>
        <Typography variant="body1" component="a" href="https://evu.dk/akkord-releasenotes/" target="_blank" rel="noopener noreferrer" sx={{ display: "block", marginBottom: 2 }}>
          {t("account.information.newsContent")}
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 3, color: "primary.main" }}>
          {t("account.information.NewsletterTitle")}
        </Typography>
        <Typography component="a" href="https://evu.peytzmail.com/f/profile/akkord-tilmeldingsformular" target="_blank" rel="noopener noreferrer" sx={{ display: "block", marginBottom: 2 }}>
          {t("account.information.NewsletterLink")}
        </Typography>
      </Box>

      <Divider sx={{ margin: "16px 0 24px 0" }} />

      <Box sx={{ marginTop: 2 }}>
        <Typography variant="h5" sx={{ color: "primary.main", marginBottom: 3 }}>
          {t("account.information.ContactTitle")}
        </Typography>

        {/* General Technical Support */}
        <Box sx={{ marginBottom: 2, padding: 2, backgroundColor: "primary.light", borderRadius: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}>
            <EmailIcon sx={{ marginRight: 1, color: "primary.main" }} />
            <Typography variant="h6" sx={{ color: "primary.main" }}>
              {t("account.information.ContactSupportTitle")}
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ marginBottom: 1 }}>
            {t("account.information.firstSupportText")}
          </Typography>
          <Link href={`mailto:${contactSupportMail}`} sx={{ color: "primary.main", textDecoration: "underline" }}>
            {contactSupportMail}
          </Link>
        </Box>

        {/* EVU Contact */}
        <Box sx={{ marginBottom: 2, padding: 2, backgroundColor: "primary.light", borderRadius: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}>
            <EmailIcon sx={{ marginRight: 1, color: "primary.main" }} />
            <Typography variant="h6" sx={{ color: "primary.main" }}>
              {t("account.information.ContactEvu")}
            </Typography>
          </Box>
          <Link href={`mailto:${contactEvu}`} sx={{ color: "primary.main", textDecoration: "underline" }}>
            {contactEvu}
          </Link>
        </Box>

        {/* Critical Support */}
        <Box
          sx={{
            padding: 2,
            backgroundColor: "primary.light",
            borderRadius: 2,
            marginBottom: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}>
            <WarningIcon sx={{ marginRight: 1, color: "primary.main" }} />
            <PhoneIcon sx={{ marginRight: 1, color: "primary.main" }} />
            <Typography variant="h6" sx={{ color: "primary.main", fontWeight: "bold" }}>
              {t("account.information.CriticalSupportTitle")}
            </Typography>
          </Box>
          <Box display={"flex"} flexDirection="row" gap={1}>
            <Typography variant="body1" sx={{ color: "primary.main", fontWeight: "bold" }}>
              {t("account.information.CriticalSupportText")}
            </Typography>

            {screenSize === ScreenSizeEnum.Mobile ? (
              <Link href={`tel:${criticalSupportPhone}`} sx={{ color: "secondary.main", textDecoration: "underline" }}>
                {criticalSupportPhone}
              </Link>
            ) : (
              <Typography variant="body1" sx={{ color: "secondary.main" }}>
                {criticalSupportPhone}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
      {/*this box makes sure the content is not cut off by the bottom menu */}
      <Box sx={{ p: "60px" }} />
    </Box>
  );
};
